<template>
    <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="id-modalHeadingPost"
        class="modal-dialog-post"
    >
        <header class="modal-header">
            <h1
                id="id-modalHeadingPost"
                ref="modalHeadingPost"
                tabindex="0"
                @keydown.tab="handleHeadingTab"
            >
                {{ header }}
            </h1>
            <button
                ref="modalButtonPost"
                type="button"
                class="btn-close"
                :aria-label="closeModalAriaLabel"
                @click="close"
                @keydown.esc="close"
                @keydown.tab="handleCloseButtonTab"
            />
        </header>
        <section class="modal-body modal-font">
            <p class="modal-item-info">
                {{ $t("App.Posti.Maara") }}: <span>{{ count }}</span>
            </p>
            <!-- eslint-disable vue/no-v-html -->
            <span v-html="textContent" />
            <!--eslint-enable-->
        </section>
    </div>
</template>

<script lang="ts">
    import DynamicModalData from "@/models/dynamicmodaldata"
    import { Component, Vue, Prop } from "vue-facing-decorator"

    @Component
    export default class PostitoimipisteetModal extends Vue {
        @Prop({ type: Boolean, default: false }) componentNameIsSet!: boolean

        mounted(): void {
            if (this.componentNameIsSet === true) {
                this.$nextTick(() => {
                    (this.$refs.modalHeadingPost as HTMLHeadingElement).focus()
                })
            }
        }

        close(): void {
            this.$store.dispatch("setModalComponentName", "")
        }

        get data(): DynamicModalData | null {
            return this.$store?.getters.modalData ?? null
        }

        get textContent(): string | null {
            return this.data?.textContent ?? ""
        }

        get header(): string | null {
            return this.data?.header ?? ""
        }

        get count(): string | null {
            return this.data?.count?.toString() ?? "0"
        }

        get closeModalAriaLabel(): string | undefined {
            return this.$t("App.Close")
        }

        // TODO LLa jos modaalin sis�lt��n tulee muita interaktiivisia elementtej� closeButtonin ja otsikon lis�ksi,
        // ne tulee huomioida kohdistuksen k�sittelyss� (trapFocus?)
        handleCloseButtonTab(event: KeyboardEvent): void {
            if (!event.shiftKey) /* tab */ {
                (this.$refs.modalHeadingPost as HTMLHeadingElement).focus()
                event.preventDefault()
            }
        }

        handleHeadingTab(event: KeyboardEvent): void {
            if (event.shiftKey) /* shift + tab */ {
                (this.$refs.modalButtonPost as HTMLButtonElement).focus()
                event.preventDefault()
            }
        }
    }
</script>
